import pathnames from "routes/pathnames";
import AppCompanyLogoIcon from "components/icons/app-company-logo-icon";
import AppSchedulerIcon from "components/icons/app-scheduler-icon";
import AppEmailTemplatesIcon from "components/icons/app-email-templates-icon";

const settingsNavList = [
	{
		label: "Company Logo",
		path: pathnames.settings.companyLogo,
		icon: AppCompanyLogoIcon,
		names: null,
		childrens: [],
		relatives: [],
	},
	{
		label: "Scheduler",
		path: pathnames.settings.scheduler,
		icon: AppSchedulerIcon,
		names: null,
		childrens: [],
		relatives: [],
	},
	{
		label: "Email Templates",
		path: pathnames.settings.emailTemplates,
		icon: AppEmailTemplatesIcon,
		names: null,
		childrens: [],
		relatives: [],
	},
];

export default settingsNavList;
